import styled from 'styled-components';

export const CriticalBannerStyled = styled.div`
  .Polaris-InlineStack > .Polaris-Box {
    padding-top: 0 !important;
  }
`;
